var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "validation-observer",
    { ref: "followUpFormRef", attrs: { novalidate: "", tag: "form" } },
    [
      _c("div", { staticClass: "mx-4" }, [
        _c("div", { staticClass: "row mb-3 pt-3" }, [
          _c(
            "div",
            { staticClass: "col-12" },
            [
              _c("icon-view", {
                attrs: {
                  icon: _vm.icon,
                  "icon-background": _vm.iconBackground,
                  "icon-color": _vm.iconColor,
                  "icon-size": "14px",
                  title: _vm.sectionTitle,
                  variant: "custom-icon-view"
                }
              })
            ],
            1
          )
        ]),
        _c("div", { staticClass: "row" }, [
          _c(
            "div",
            { staticClass: "col-6" },
            [
              _c("validation-provider", {
                attrs: { rules: "required" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function({ errors }) {
                      return [
                        _c("custom-drop-down", {
                          staticClass: "custom-drop-down",
                          attrs: {
                            id: "ddAdditionalSection",
                            "custom-error-msg":
                              "Es requerido seleccionar una Categoría.",
                            error: errors[0],
                            fieldkey: "id",
                            fieldname: "name",
                            label: _vm.ddTitle,
                            options: _vm.options
                          },
                          model: {
                            value: _vm.model.selectedOption,
                            callback: function($$v) {
                              _vm.$set(_vm.model, "selectedOption", $$v)
                            },
                            expression: "model.selectedOption"
                          }
                        })
                      ]
                    }
                  }
                ])
              })
            ],
            1
          ),
          _c("div", {
            staticClass:
              "col-2 order-2 order-md-0 order-sm-1 mt-3 mt-md-0 mt-sm-3"
          })
        ]),
        _c("div", { staticClass: "row" }, [
          _c(
            "div",
            { staticClass: "col-12 mt-3" },
            [
              _c("validation-provider", {
                attrs: { rules: "required" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function({ errors }) {
                      return [
                        _c("custom-text-area", {
                          attrs: {
                            id: "txtAdditionalSectionComment",
                            "custom-error-msg":
                              "Es requerido documentar un comentario.",
                            error: errors[0],
                            label: "Comentario:",
                            maxlength: 2000,
                            "show-char-count": ""
                          },
                          model: {
                            value: _vm.model.comment,
                            callback: function($$v) {
                              _vm.$set(_vm.model, "comment", $$v)
                            },
                            expression: "model.comment"
                          }
                        })
                      ]
                    }
                  }
                ])
              })
            ],
            1
          )
        ]),
        _c("div", { staticClass: "row mt-5 mt-md-0 mt-sm-3 pb-3 pt-3" }, [
          _c(
            "div",
            {
              staticClass:
                "col-5 d-flex justify-content-start align-items-center"
            },
            [
              _c("check-box", {
                staticClass: "w-auto",
                model: {
                  value: _vm.openAdditionalSection,
                  callback: function($$v) {
                    _vm.openAdditionalSection = $$v
                  },
                  expression: "openAdditionalSection"
                }
              }),
              _c(
                "span",
                { staticClass: "mr-2 color-gray-7 font-weight-bold font-16" },
                [_vm._v(" " + _vm._s(_vm.chkTitle) + " ")]
              )
            ],
            1
          ),
          !_vm.openAdditionalSection
            ? _c(
                "div",
                {
                  staticClass:
                    "col-7 d-flex align-items-center justify-content-md-end justify-content-sm-none"
                },
                [
                  _c(
                    "action-button",
                    {
                      attrs: {
                        i: "fas fa-times-circle",
                        variant: "outline-danger btn-cancel danger px-3 mr-2"
                      },
                      on: {
                        click: function($event) {
                          return _vm.onCancel()
                        }
                      }
                    },
                    [_vm._v(" Cancelar ")]
                  ),
                  _c(
                    "action-button",
                    {
                      attrs: { i: "fas fa-save", variant: "success px-3" },
                      on: {
                        click: function($event) {
                          return _vm.onConfirm()
                        }
                      }
                    },
                    [_vm._v(" Guardar ")]
                  )
                ],
                1
              )
            : _vm._e()
        ]),
        _vm.openAdditionalSection
          ? _c(
              "div",
              [
                _c("hr"),
                _c("div", { staticClass: "row mb-3 pt-4" }, [
                  _c(
                    "div",
                    { staticClass: "col-12" },
                    [
                      _c("icon-view", {
                        attrs: {
                          icon: _vm.icon,
                          "icon-background": _vm.iconBackground,
                          "icon-color": _vm.iconColor,
                          "icon-size": "14px",
                          title: _vm.chkTitle,
                          variant: "custom-icon-view"
                        }
                      })
                    ],
                    1
                  )
                ]),
                _vm.assistanceSummariesRelated
                  ? _c("additional-child-section", {
                      attrs: {
                        "assistance-summaries": _vm.assistanceSummariesRelated,
                        "message-error": _vm.messageError,
                        "show-status-indicator": _vm.showStatusIndicator
                      },
                      on: { "on-set-list": _vm.onSetList }
                    })
                  : _vm._e(),
                _c("div", { staticClass: "row" }, [
                  _c(
                    "div",
                    {
                      staticClass:
                        "col-12 d-flex align-items-center justify-content-md-end justify-content-sm-none my-4"
                    },
                    [
                      _c(
                        "action-button",
                        {
                          attrs: {
                            i: "fas fa-times-circle",
                            variant:
                              "outline-danger btn-cancel danger px-3 mr-2"
                          },
                          on: {
                            click: function($event) {
                              return _vm.onCancel()
                            }
                          }
                        },
                        [_vm._v(" Cancelar ")]
                      ),
                      _c(
                        "action-button",
                        {
                          attrs: { i: "fas fa-save", variant: "success px-3" },
                          on: {
                            click: function($event) {
                              return _vm.onConfirm()
                            }
                          }
                        },
                        [_vm._v(" Guardar ")]
                      )
                    ],
                    1
                  )
                ])
              ],
              1
            )
          : _vm._e()
      ])
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }